import React from "react";
import "../../styles/about.scss";

export default function NewAbout(props) {
  return (
    <div className="top-padding-main inter">
      <div>
        <div className="row">
          <div className="col-md-12 new-main-about-container">
            <div
              className="new-about-us-container"
              style={{
                position: "relative",
                width: "98%",
                height: "auto",
                borderRadius: "14px",
                overflow: "hidden",
              }}
            >
              {/* Background image with opacity */}
              <div
                style={{
                  backgroundImage: "url('/assets/images/new_temp_about_us_bg.webp')",
                  backgroundSize: "cover",
                  backgroundRepeat: "repeat",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  opacity: 0.4,
                  zIndex: 1,
                }}
              />

              <div
                className="new-about-content-container d-flex flex-column justify-content-center"
                style={{ height: "100%", position: "relative", zIndex: 2 }}
              >
                <h2 className="new-heading">About {`${props?.partner?.partner_name}`}</h2>
                <p
                  className="table-details"
                  style={{ color: "#fff", textAlign: "left" }}
                >
                  {`${props?.partner?.partner_name}`} now offers innovative
                  Buy-Before-You-Sell solutions powered by Calque, a fintech
                  company that provides a binding backup contract—known as a
                  Purchase Price Guarantee (PPG)—on a borrower’s home. This
                  enables loan officers to eliminate home sale contingencies,
                  enabling borrowers to submit stronger offers with the
                  confidence that their current home will sell no matter what.
                  Calque is not a lender—think of us as a backup buyer,
                  providing greater convenience, confidence, and success
                  throughout the process.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
